/**
 * Material Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { FormOutlined, OrderedListOutlined, PlusOutlined, HomeOutlined, AppstoreOutlined, ShopOutlined, PullRequestOutlined, CheckCircleOutlined, EyeOutlined, CalculatorOutlined, SwapOutlined, SwapRightOutlined, SwapLeftOutlined, LeftCircleOutlined, ExperimentOutlined, CarryOutOutlined, RetweetOutlined } from '@ant-design/icons';
import { TbTruckDelivery } from 'react-icons/tb';
import { GiCargoShip, GiForklift } from 'react-icons/gi';
import { MdPallet } from 'react-icons/md';

import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';
import MatFormsCreate from '../pages/material/forms/MatFormsCreate';
import MatFormFill from '../pages/material/forms/MatFormFill';
import MatFormList from "../pages/material/forms/MatFormList";
import MatFormEdit from '../pages/material/forms/MatFormEdit';
import MatFormView from '../pages/material/forms/MatFormView';
import MatFormGroupCreate from "../pages/material/forms/MatFormGroupCreate";

import MatGapMasterList from "../pages/material/matgaplists/MatGapMasterList";
import MatGapMasterImport from "../pages/material/MatGapMasterImport";
import MatGapWhouses from '../pages/material/MatGapWhouses';
import MatClntWhouses from '../pages/material/MatClntWhouses';
import MatGapMatLedger from '../pages/material/matgaplists/MatGapMatLedger';
import MatClntMasterList from '../pages/material/matclntlists/MatClntMasterList';
import MatClntDeliveries from '../pages/material/matclntlists/MatClntDeliveries';
import MatGapDeliveries from "../pages/material/matgaplists/MatGapDeliveries";
import MatGapPreDelivery from "../pages/material/matgaplists/MatGapPreDelivery";
import MatGapInventory from "../pages/material/matgaplists/MatGapInventory";
import MatGapTxnIncoming from "../pages/material/matgaptxns/MatGapTxnIncoming";
import MatGapTxnTransfer from "../pages/material/matgaptxns/MatGapTxnTransfer";
import MatGapTxnIssue from "../pages/material/matgaptxns/MatGapTxnIssue";
import MatGapTxnAssign from "../pages/material/matgaptxns/MatGapTxnAssign";
import MatGapTxnReturn from "../pages/material/matgaptxns/MatGapTxnReturn";
import MatGapTxnList from "../pages/material/matgaplists/MatGapTxnList";
import MatGapIncomingList from "../pages/material/matgaplists/MatGapIncomingList";
import MatGapTransferList from "../pages/material/matgaplists/MatGapTransferList";
import MatGapIssueList from "../pages/material/matgaplists/MatGapIssueList";
import MatGapAssignmentList from "../pages/material/matgaplists/MatGapAssignmentList";
import MatGapReturnList from "../pages/material/matgaplists/MatGapReturnList";
import MatGapSendbackList from "../pages/material/matgaplists/MatGapSendbackList";
import MatGapAdjustmentList from "../pages/material/matgaplists/MatGapAdjustmentList";
import MatGapIssueRequestCreate from "../pages/material/matgapissuereq/MatGapIssueRequestCreate";
import MatGapIssueRequestEdit from "../pages/material/matgapissuereq/MatGapIssueRequestEdit";
import MatGapIssueRequestsGeneral from '../pages/material/matgapissuereq/MatGapIssueRequestsGeneral';
import MatGapIssueRequestDetails from '../pages/material/matgapissuereq/MatGapIssueRequestDetails';
import MatGapIssueRequestsItemList from "../pages/material/matgapissuereq/MatGapIssueRequestsItemList";

import ChemicalMaterialMain from '../pages/material/ChemicalMaterialMain';
import ChemicalMaterialList from '../pages/material/ChemicalMaterialList';
import ChemicalMaterialCreate from '../pages/material/ChemicalMaterialCreate';
import MatClntTxnIncoming from "../pages/material/matclnttxns/MatClntTxnIncoming";
import MatClntIssueRequestCreate from "../pages/material/matclntissuereq/MatClntIssueRequestCreate";
import MatClntIssueRequestDetails from "../pages/material/matclntissuereq/MatClntIssueRequestDetails";
import MatClntIssueRequestEdit from "../pages/material/matclntissuereq/MatClntIssueRequestEdit";
import MatClntIssueRequestsGeneral from "../pages/material/matclntissuereq/MatClntIssueRequestsGeneral";
import MatClntIssueRequestsItemList from "../pages/material/matclntissuereq/MatClntIssueRequestsItemList";
import MatClntTxnIssue from "../pages/material/matclnttxns/MatClntTxnIssue";
import MatClntTxnTransfer from "../pages/material/matclnttxns/MatClntTxnTransfer";

import MatLogInvoices from '../pages/material/logistics/MatLogInvoices';
import MatClntTxnAssign from "../pages/material/matclnttxns/MatClntTxnAssign";
import MatClntTxnReturn from "../pages/material/matclnttxns/MatClntTxnReturn";
import MatClntTxnList from "../pages/material/matclntlists/MatClntTxnList";
import MatClntTransferList from "../pages/material/matclntlists/MatClntTransferList";
import MatClntIssueList from "../pages/material/matclntlists/MatClntIssueList";
import MatClntReturnList from "../pages/material/matclntlists/MatClntReturnList";
import MatClntIncomingList from "../pages/material/matclntlists/MatClntIncomingList";
import MatClntAssignmentList from "../pages/material/matclntlists/MatClntAssignmentList";
import MatClntInventory from "../pages/material/matclntlists/MatClntInventory";
import MatClntMatLedger from "../pages/material/matclntlists/MatClntMatLedger";
import MatLogMpplList from "../pages/material/logistics/MatLogMpplList";
import MatLogShipmentList from "../pages/material/logistics/MatLogShipmentList";
import MatLogShipmentCreate from "../pages/material/logistics/MatLogShipmentCreate";
import MatLogShipmentEdit from "../pages/material/logistics/MatLogShipmentEdit";
import MatLogPackageList from "../pages/material/logistics/MatLogPackageList";
import MatLogPackageCreate from "../pages/material/logistics/MatLogPackageCreate";
import MatLogPackageEdit from "../pages/material/logistics/MatLogPackageEdit";

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

// Wrappers for react-icons typing
const RTbTruckDelivery: React.FC<any> = (props) =>
  React.createElement(TbTruckDelivery as unknown as React.ComponentType<any>, props) as React.ReactElement;
const RGiForklift: React.FC<any> = (props) =>
  React.createElement(GiForklift as unknown as React.ComponentType<any>, props) as React.ReactElement;
const RGiCargoShip: React.FC<any> = (props) =>
  React.createElement(GiCargoShip as unknown as React.ComponentType<any>, props) as React.ReactElement;
const RMdPallet: React.FC<any> = (props) =>
  React.createElement(MdPallet as unknown as React.ComponentType<any>, props) as React.ReactElement;

export const materialRoutes: Record<string, RouteItem> = {
  // MATERIAL module
  material: {path: '/material', element: null, label: 'Material', showInMenu: false,
    children: {
      dashboard: {path: '/material/dashboard', element: <UnderConstruction title="Material" />, label: 'Dashboard', icon: <HomeOutlined />, showInMenu: true},
      forms: {path: '/material/forms', element: <MatFormList />, label: 'Forms', icon: <FormOutlined />, showInMenu: true,
        grandchildren: {
          list: {path: '/material/forms/list', element: <MatFormList/>, label: 'Form List', icon: <OrderedListOutlined />, showInMenu: true},
          definitions: {path: '/material/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true},
          definitions_create: {path: '/material/forms/definitions/create', element: <PdfToReactFormGenerator />, label: 'Create Form Definition', showInMenu: false},
          definitions_edit: {path: '/material/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false},
          list_record_details: {path: '/material/forms/list_record_details', element: <FormRecordDetailsList />, label: 'Form Record Details', icon: <OrderedListOutlined />, showInMenu: true},
          group: {path: '/material/forms/gr_create', element: <MatFormGroupCreate />, label: 'New Form Group', icon: <PlusOutlined />, showInMenu: true},
          create: {path: '/material/forms/create', element: <MatFormsCreate/>, label: 'Create Form', icon: <PlusOutlined />, showInMenu: true},
          fill: {path: '/material/forms/fill', element: <MatFormFill/>, label: 'Fill Form',  showInMenu: true},
          edit: {path: '/material/forms/edit/:id', element: <MatFormEdit />, label: 'Edit Form', showInMenu: false},
          view: {path: '/material/forms/view/:id', element: <MatFormView />, label: 'View Form', showInMenu: false},
        },
      },
      sap: {path: '/material/sap', element: <UnderConstruction title="SAP" />, label: 'SAP', icon: <AppstoreOutlined />, showInMenu: true},
      gapMaterial: {path: '/material/gap-material', element: <MatGapMasterList/>, label: 'GAP Material', icon: <RGiForklift size={20}/>, showInMenu: true,
        children: {
          list : {path: '/material/gap-material/master', element: <MatGapMasterList />, label: 'Master', icon: <OrderedListOutlined />, showInMenu: true,
            grandchildren: {
              list: {path: '/material/gap-material/master/list', element: <MatGapMasterList/>, label: 'Master List', icon: <OrderedListOutlined />, showInMenu: true},
              preDelivery: {path: '/material/gap-material/master/pre-delivery', element: <MatGapPreDelivery/>, label: 'Pre-Delivery', icon: <OrderedListOutlined />, showInMenu: true},
              import: {path: '/material/gap-material/master/import', element: <MatGapMasterImport/>, label: 'Import', icon: <PlusOutlined />, showInMenu: true},
              warehouses: {path: '/material/gap-material/master/warehouses', element: <MatGapWhouses />, label: 'Warehouses', icon: <ShopOutlined />, showInMenu: true},
            }},
          lists : {path: '/material/gap-material/lists', element: null, label: 'Lists', icon: <OrderedListOutlined />, showInMenu: true,
            grandchildren: {
              transactions: { path: '/material/gap-material/lists/transactions', element: <MatGapTxnList />, label: 'All', icon: <OrderedListOutlined />, showInMenu: true },
              incoming: { path: '/material/gap-material/lists/incoming', element: <MatGapIncomingList />, label: 'Incomings', icon: <RTbTruckDelivery size={20}/>, showInMenu: true },
              transfers: { path: '/material/gap-material/lists/transfers', element: <MatGapTransferList />, label: 'Transfers', icon: <OrderedListOutlined />, showInMenu: true },
              issues: { path: '/material/gap-material/lists/issues', element: <MatGapIssueList />, label: 'Issues', icon: <OrderedListOutlined />, showInMenu: true},
              assignments: { path: '/material/gap-material/lists/assignments', element: <MatGapAssignmentList />, label: 'Assignments', icon: <OrderedListOutlined />, showInMenu: true },
              returns: { path: '/material/gap-material/lists/returns', element: <MatGapReturnList />, label: 'Returns', icon: <OrderedListOutlined />, showInMenu: true },
              sendbacks: { path: '/material/gap-material/lists/sendbacks', element: <MatGapSendbackList />, label: 'Sendbacks', icon: <OrderedListOutlined />, showInMenu: true },
              adjustments: { path: '/material/gap-material/lists/adjustments', element: <MatGapAdjustmentList />, label: 'Adjustments', icon: <CalculatorOutlined/>, showInMenu: true },
              ledger: { path: '/material/gap-material/lists/ledger', element: <MatGapMatLedger />, label: 'Ledger', icon: <OrderedListOutlined />, showInMenu: true },
              deliveries: {path: '/material/gap-material/deliveries', element: <MatGapDeliveries />, label: 'Deliveries', icon: <OrderedListOutlined />, showInMenu: true},
              inventory: {path: '/material/gap-material/inventory', element: <MatGapInventory />, icon: <OrderedListOutlined />,label: 'Inventory', showInMenu: true},
            }
          },
          issueRequest: {path: '/material/gap-material/issue-request', element: <MatGapIssueRequestsGeneral />, label: 'Issue Requests', icon:<PullRequestOutlined/>,showInMenu: true,
            grandchildren: {
              listgen: {path: '/material/gap-material/issue-request/list', element: <MatGapIssueRequestsGeneral />, label: 'Issue Request List', icon: <OrderedListOutlined />, showInMenu: true},
              list:   {path: '/material/gap-material/issue-request/listitems', element: <MatGapIssueRequestsItemList />, label: 'Issue Request Items', icon: <OrderedListOutlined />, showInMenu: true},
              view:   {path: '/material/gap-material/issue-request/view/:id', element: <MatGapIssueRequestDetails />, label: 'View Issue Request', icon: <EyeOutlined />, showInMenu: false},
              edit:   {path: '/material/gap-material/issue-request/edit/:id', element: <MatGapIssueRequestEdit />, label: 'Edit Issue Request', icon: <FormOutlined />, showInMenu: false},
              create: {path: '/material/gap-material/issue-request/create', element: <MatGapIssueRequestCreate />, label: 'Create Issue Request', icon: <PlusOutlined />, showInMenu: true},
            }
          },
          operations: {path: '/material/gap-material/operations', element: null, label: 'Operations', icon:<CheckCircleOutlined/>, showInMenu: true,
            grandchildren: {
              incoming: {path: '/material/gap-material/operations/incoming', element: <MatGapTxnIncoming />, label: 'Incoming', icon:<RTbTruckDelivery size={20}/>, showInMenu: true},
              transfer: {path: '/material/gap-material/operations/transfer', element: <MatGapTxnTransfer />, label: 'Transfer', icon:<SwapOutlined/>,showInMenu: true},
              issue: {path: '/material/gap-material/operations/issue', element: <MatGapTxnIssue />, label: 'Issue', icon:<SwapRightOutlined/>, showInMenu: true},
              assign: {path: '/material/gap-material/operations/assign', element: <MatGapTxnAssign />, label: 'Assign', icon:<RetweetOutlined/>,showInMenu: true},
              return: {path: '/material/gap-material/operations/return', element: <MatGapTxnReturn />, label: 'Return', icon:<SwapLeftOutlined/>, showInMenu: true},
              sendback: {path: '/material/gap-material/operations/sendback', element: <UnderConstruction title="Sendback" />, label: 'Sendback', icon:<LeftCircleOutlined/>,showInMenu: true},
              adjustment: {path: '/material/gap-material/operations/adjustments', element: <UnderConstruction title="Adjustments" />, label: 'Adjustment', icon:<CalculatorOutlined/>,showInMenu: true}
            },
          },
        },
      },
      clientMaterial: {
        path: '/material/client',
        element: <MatClntWhouses/>,
        label: 'Client Material',
        icon: <RGiForklift size={20}/>, showInMenu: true,
        children: {
          lists: {path: '/material/client/master', element: <MatClntMasterList/>, label: 'Master', icon: <OrderedListOutlined/>,  showInMenu: true,
            grandchildren: {
              master: { path: '/material/client/master', element: <MatClntMasterList/>,label: 'Master',  icon: <OrderedListOutlined/>,  showInMenu: true, },
              warehouses: { path: '/material/client/warehouses', element: <MatClntWhouses/>, label: 'Warehouses', icon: <ShopOutlined/>,showInMenu: true,}
            },
          },
          lists_txn: {
            path: '/material/client/lists',
            element: null,
            label: 'Lists',
            icon: <OrderedListOutlined/>,
            showInMenu: true,
            grandchildren: {
              transactions: { path: '/material/client/lists/transactions', element: <MatClntTxnList />, label: 'All', icon: <OrderedListOutlined />, showInMenu: true },
              incoming: { path: '/material/client/lists/incoming', element: <MatClntIncomingList />, label: 'Incomings', icon: <RTbTruckDelivery size={20}/> , showInMenu: true },
              transfers: { path: '/material/client/lists/transfers', element: <MatClntTransferList />, label: 'Transfers', icon: <OrderedListOutlined />, showInMenu: true },
              issues: { path: '/material/client/lists/issues', element: <MatClntIssueList />, label: 'Issues', icon: <OrderedListOutlined />, showInMenu: true },
              assignments: { path: '/material/client/lists/assignments', element: <MatClntAssignmentList />, label: 'Assignments', icon: <OrderedListOutlined />, showInMenu: true },
              returns: { path: '/material/client/lists/returns', element: <MatClntReturnList />, label: 'Returns', icon: <OrderedListOutlined />, showInMenu: true },
              deliveries: { path: '/material/client/lists/deliveries', element: <MatClntDeliveries/>,label: 'Deliveries', icon: <OrderedListOutlined/>, showInMenu: true,},
              inventory: { path: '/material/client/lists/inventory', element: <MatClntInventory />, label: 'Inventory', icon: <OrderedListOutlined />, showInMenu: true },
              ledger: { path: '/material/client/lists/ledger', element: <MatClntMatLedger />, label: 'Ledger', icon: <OrderedListOutlined />, showInMenu: true },
            }
          },
          issueRequest: { path: '/material/client/issue-request/list', element: null,label: 'Issue Requests', icon: <PullRequestOutlined/>, showInMenu: true,
            grandchildren: {
              listgen: { path: '/material/client/issue-request/list', element: <MatClntIssueRequestsGeneral />, label: 'Issue Request List',icon: <OrderedListOutlined />, showInMenu: true, },
              list: { path: '/material/client/issue-request/listitems', element: <MatClntIssueRequestsItemList />, label: 'Issue Request Items', icon: <OrderedListOutlined />,showInMenu: true,},
              create: {path: '/material/client/issue-request/create', element: <MatClntIssueRequestCreate />, label: 'Create Issue Request', icon: <PlusOutlined />,  showInMenu: true, },
              view: { path: '/material/client/issue-request/view/:id', element: <MatClntIssueRequestDetails />, label: 'View Client Issue Request', icon: <EyeOutlined />, showInMenu: false, },
              edit: { path: '/material/client/issue-request/edit/:id', element: <MatClntIssueRequestEdit />, label: 'Edit Client Issue Request', icon: <FormOutlined />, showInMenu: false,   },
            },
          },
          operations: { path: '/material/client/operations', element: null, label: 'Operations', icon: <OrderedListOutlined/>, showInMenu: true,
            grandchildren: {
              incoming: { path: '/material/client/operations/incoming', element: <MatClntTxnIncoming />, label: 'Incoming', icon: <RTbTruckDelivery size={20}/>, showInMenu: true,},
              transfer: { path: '/material/client/operations/transfer', element: <MatClntTxnTransfer />, label: 'Transfer', icon: <SwapOutlined/>, showInMenu: true },
              issue: { path: '/material/client/operations/issue',element: <MatClntTxnIssue />,label: 'Issue', icon: <SwapRightOutlined/>,showInMenu: true, },
              assign: { path: '/material/client/operations/assign', element: <MatClntTxnAssign />, label: 'Assign', icon: <RetweetOutlined/>, showInMenu: true },
              return: { path: '/material/client/operations/return', element: <MatClntTxnReturn />, label: 'Return', icon: <SwapLeftOutlined/>, showInMenu: true },
              sendback: { path: '/material/client/operations/sendback', element: <UnderConstruction title="Client Material Sendback" />, label: 'Sendback', icon: <LeftCircleOutlined/>, showInMenu: true },
              adjustment: { path: '/material/client/operations/adjustment', element: <UnderConstruction title="Client Material Adjustment" />, label: 'Adjustment', icon: <CalculatorOutlined/>, showInMenu: true },

            },
          },
        },
      },
      customs: { path: '/material/customs', element: <UnderConstruction title="Customs" />, label: 'Customs', icon: <CarryOutOutlined />, showInMenu: true,},
      logistics: {  path: '/material/logistics', element: <MatLogMpplList />,label: 'Logistics',
        icon: <RTbTruckDelivery size={20} />,
        showInMenu: true,
        children: {
          mppl: {
            path: '/material/logistics/mppl-list',
            element: <MatLogMpplList />,
            label: 'MPPL List',
            icon: <OrderedListOutlined />,
            showInMenu: true,
          },
          shipments_list: {
            path: '/material/logistics/shipments/list',
            element: <MatLogShipmentList />,
            label: 'Shipments',
            icon: <RGiCargoShip size={20} />,
            showInMenu: true,
          },
          shipments_create: {
            path: '/material/logistics/shipments/create',
            element: <MatLogShipmentCreate />,
            label: 'Create Shipment',
            icon: <PlusOutlined />,
            showInMenu: true,
          },
          shipments_edit: {
            path: '/material/logistics/shipments/edit/:shipment_id',
            element: <MatLogShipmentEdit />,
            label: 'Edit Shipment',
            showInMenu: false,
          },
          packages_list: {
            path: '/material/logistics/packages',
            element: <MatLogPackageList />,
            label: 'Packages',
            icon: <RMdPallet size={20} />,
            showInMenu: true,
          },
          packages_create: {
            path: '/material/logistics/packages/create',
            element: <MatLogPackageCreate />,
            label: 'Create Package',
            icon: <PlusOutlined />,
            showInMenu: true,
          },
          packages_edit: {
            path: '/material/logistics/packages/edit/:id',
            element: <MatLogPackageEdit />,
            label: 'Edit Package',
            showInMenu: false,
          },
          packages_edit_multi: {
            path: '/material/logistics/packages/edit-multi',
            element: <MatLogPackageEdit />,
            label: 'Edit Packages',
            showInMenu: false,
          },
          invoices: {
            path: '/material/logistics/invoices',
            element: <MatLogInvoices />,
            label: 'Invoices',
            icon: <OrderedListOutlined />,
            showInMenu: true,
          },
        },
      },
      chemicalMaterial: { path: '/material/chemical-material',element: <ChemicalMaterialMain />,label: 'Chemical Material', icon: <ExperimentOutlined />,showInMenu: true,
        children: {
          dashboard: { path: '/material/chemical-material/dashboard', element: <ChemicalMaterialMain />, label: 'Dashboard', icon: <ExperimentOutlined />,showInMenu: true,},
          list: { path: '/material/chemical-material/list', element: <ChemicalMaterialList />, label: 'List', icon: <ExperimentOutlined />, showInMenu: true, },
          add: { path: '/material/chemical-material/add', element: <ChemicalMaterialCreate />,label: 'Add', icon: <ExperimentOutlined />, showInMenu: true,},
        },
      },
    },
  },
};
